export function escapeHtml(value) {
    return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

export function phoneHref(value) {
    return String(value ?? '').replace(/[^\d+]/g, '');
}

export function emailHref(value) {
    return encodeURIComponent(String(value ?? '').trim());
}
